import React from "react";
import { Modal, ModalBody, Button, Spinner } from "reactstrap";

const DeleteModal = ({
  isOpen,
  toggle,
  onConfirm,
  loading = false,
  title = "Are you sure?",
  text = "Are you sure you want to delete this resale property listing? This action cannot be undone.",
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
      <ModalBody className="text-center p-4">
        <div className="mb-3">
          <i className="mdi mdi-alert-circle-outline text-danger" style={{ fontSize: "56px" }}></i>
        </div>
        <h5 className="fw-bold mb-2">{title}</h5>
        <p className="text-muted font-size-13 mb-4">{text}</p>
        <div className="d-flex justify-content-center gap-2">
          <Button color="light" className="px-3" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="danger" className="px-3" onClick={onConfirm} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Yes, Delete"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
